import { TServerErrorResponse } from "@/types";
import { http } from "../httpHandler";
import { links } from "@/constants";
import { SummarizerSettingEntity } from "@/types/summarizer-settings";

export const SUMMARIZER_GET_ALL = "summarizer-get-all";

export const getAllSummarizerSettings = async () => {
  try {
    const response = await http.get<SummarizerSettingEntity[]>(
      links.summarizerSettings.index,
    );
    return response.data || [];
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const updateSummarizerSetting = async (
  setting: Pick<SummarizerSettingEntity, "summarizerType" | "name" | "enabled">,
) => {
  try {
    const response = await http.put<SummarizerSettingEntity>(
      links.summarizerSettings.summarizerSettingByKey(
        setting.summarizerType,
        setting.name,
      ),
      { enabled: setting.enabled },
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
